"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = function _default(obj, predicate) {
  var rtnObj = {};
  Object.keys(obj).forEach(function (key) {
    if (predicate(key, obj[key])) {
      rtnObj[key] = obj[key];
    }
  });
  return rtnObj;
};